import type { NaverMember } from "../data/users";
import { Link } from "react-router-dom";

type Props = {
  users: NaverMember[];
  sortOrder: "asc" | "desc";
  onSortToggle: () => void;
  readOnly?: boolean;
};

export default function MaskedTable({
  users,
  sortOrder,
  onSortToggle,
  readOnly = false,
}: Props) {

  return (
    <div className="tw-bg-white tw-border tw-border-slate-200 tw-rounded-2xl tw-overflow-hidden">

      <table className="tw-w-full tw-table-fixed tw-text-sm">

        <thead className="tw-text-xs tw-uppercase tw-text-slate-500 tw-bg-slate-50">
          <tr>
            <th className="tw-w-[12%] tw-py-4 tw-px-6 tw-text-left">이름</th>
            <th className="tw-w-[15%] tw-py-4 tw-px-6 tw-text-left">전화번호</th>
            <th className="tw-w-[23%] tw-py-4 tw-px-6 tw-text-left">이메일</th>
            <th className="tw-w-[38%] tw-py-4 tw-px-6 tw-text-left">캠페인명</th>
            <th
              className={`tw-w-[12%] tw-py-4 tw-px-6 tw-select-none ${
                readOnly
                  ? ""
                  : "tw-cursor-pointer hover:tw-text-slate-800"
              }`}
              onClick={readOnly ? undefined : onSortToggle}
            >
              <div className="tw-flex tw-items-center tw-justify-between">
                <span>가입일</span>
                <span style={{ fontSize: "8px" }}>{sortOrder === "desc" ? "▼" : "▲"}</span>
              </div>
            </th>
          </tr>
        </thead>

        <tbody className="tw-divide-y tw-divide-slate-100">
          {users.map((u, i) => (
            <tr key={i} className="hover:tw-bg-slate-50">
              <td className="tw-py-4 tw-px-6 tw-font-medium">
                {u.name || "-"}
              </td>
              <td className="tw-py-4 tw-px-6">
                {u.mobile || "-"}
              </td>
              <td className="tw-py-4 tw-px-6 tw-truncate">
                <span className="tw-bg-slate-100 tw-px-3 tw-py-1 tw-rounded-md tw-text-xs tw-font-mono">
                  {u.email || "-"}
                </span>
              </td>
              <td className="tw-py-4 tw-px-6 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis">
                {u.cmpnId && !readOnly ? (
                  <Link
                    to={`/sent/detail/${u.cmpnId}`}
                    className="tw-text-[#5D87FF] hover:tw-text-blue-700 hover:tw-underline"
                  >
                    {u.campaignName || "-"}
                  </Link>
                ) : (
                  <span>{u.campaignName || "-"}</span>
                )}
              </td>
              <td className="tw-py-4 tw-px-6 tw-text-slate-500">
                {formatDate(u.createdAt)}
              </td>
            </tr>
          ))}
        </tbody>

      </table>

    </div>
  );
}

function formatDate(date: string) {
  if (!date) return "-";
  const d = new Date(date);
  return d.toLocaleDateString("ko-KR");
}
